import React from 'react';
import { CTAButton } from './CTAButton';
export const BenefitsSections = () => {
  return <>
      <section id="benefits" className="w-full bg-white py-12 px-4" data-id="element-20">
        <div className="max-w-4xl mx-auto" data-id="element-21">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-teal-700 mb-8" data-id="element-22">
            Real‑World Proof
          </h2>
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-23">
            <div className="md:w-1/2" data-id="element-24">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9jP8Pb6FQA3YjhnSpzRej8/walkingSpecialist.webp" alt="Movement specialist reviewing Ardava sleeve" className="w-full rounded-lg" data-id="element-25" />
            </div>
            <div className="md:w-1/2" data-id="element-26">
              <p className="text-gray-700" data-id="element-27">
                An independent movement specialist who reviewed Ardava told us
                she routinely sees people abandon sleeves after an hour or two
                because they're hot or irritating. With Ardava, her wear‑testers
                reported comfortable all‑day use and fewer mid‑day
                readjustments—especially on stairs and longer walks.
              </p>
            </div>
          </div>
          <CTAButton data-id="element-28" />
        </div>
      </section>
      <section className="w-full bg-gray-50 py-12 px-4" data-id="element-29">
        <div className="max-w-4xl mx-auto" data-id="element-30">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-teal-700 mb-8" data-id="element-31">
            Compare Your Options
          </h2>
          <div className="overflow-x-auto" data-id="element-32">
            <table className="min-w-full bg-white border border-gray-200 rounded-lg" data-id="element-33">
              <thead data-id="element-34">
                <tr className="bg-teal-50" data-id="element-35">
                  <th className="py-3 px-4 text-left border-b" data-id="element-36"></th>
                  <th className="py-3 px-4 text-left border-b font-semibold text-teal-700" data-id="element-37">
                    Ardava Bamboo Sleeve
                  </th>
                  <th className="py-3 px-4 text-left border-b font-semibold" data-id="element-38">
                    Cheap Neoprene Sleeve
                  </th>
                  <th className="py-3 px-4 text-left border-b font-semibold" data-id="element-39">
                    Bulky Medical Brace
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-40">
                <tr data-id="element-41">
                  <td className="py-3 px-4 border-b font-medium" data-id="element-42">
                    All‑day comfort
                  </td>
                  <td className="py-3 px-4 border-b text-teal-700 font-medium" data-id="element-43">
                    High
                  </td>
                  <td className="py-3 px-4 border-b" data-id="element-44">Low (hot/sweaty)</td>
                  <td className="py-3 px-4 border-b" data-id="element-45">Low (bulky)</td>
                </tr>
                <tr data-id="element-46">
                  <td className="py-3 px-4 border-b font-medium" data-id="element-47">Stays put</td>
                  <td className="py-3 px-4 border-b text-teal-700 font-medium" data-id="element-48">
                    Tapered cuff + micro‑grip
                  </td>
                  <td className="py-3 px-4 border-b" data-id="element-49">Frequent tugging</td>
                  <td className="py-3 px-4 border-b" data-id="element-50">Stable but bulky</td>
                </tr>
                <tr data-id="element-51">
                  <td className="py-3 px-4 border-b font-medium" data-id="element-52">
                    Breathability
                  </td>
                  <td className="py-3 px-4 border-b text-teal-700 font-medium" data-id="element-53">
                    High
                  </td>
                  <td className="py-3 px-4 border-b" data-id="element-54">Low</td>
                  <td className="py-3 px-4 border-b" data-id="element-55">Medium</td>
                </tr>
                <tr data-id="element-56">
                  <td className="py-3 px-4 border-b font-medium" data-id="element-57">
                    Typical price (per knee)
                  </td>
                  <td className="py-3 px-4 border-b text-teal-700 font-medium" data-id="element-58">
                    $39.99 (or $32.50 each as pair)
                  </td>
                  <td className="py-3 px-4 border-b" data-id="element-59">$10–$15</td>
                  <td className="py-3 px-4 border-b" data-id="element-60">$120+</td>
                </tr>
                <tr data-id="element-61">
                  <td className="py-3 px-4 border-b font-medium" data-id="element-62">Best for</td>
                  <td className="py-3 px-4 border-b text-teal-700 font-medium" data-id="element-63">
                    Daily wear, walks, stairs
                  </td>
                  <td className="py-3 px-4 border-b" data-id="element-64">Short stints</td>
                  <td className="py-3 px-4 border-b" data-id="element-65">
                    Post‑injury, short stints
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="mt-4 text-sm text-gray-600 italic" data-id="element-66">
            Small‑Batch Note: Weekly batches keep feel and finish consistent.
            When a size sells out, restock typically lands in 2–3 weeks.
          </p>
        </div>
      </section>
    </>;
};